import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@common/ui/Page';

import { DatingHome } from '@widgets/matchmaker/DatingHome';

export const Route = createFileRoute('/dating/')({
  component: Component,
});

export default function Component() {
  return (
    <Page style={{ padding: 0, paddingBottom: 8 }}>
      <DatingHome />
    </Page>
  );
}
